import React from "react";

import { SpreadsheetColumnDefinition } from "../../types/data/SpreadsheetConfiguration";
import ImportGridHeaderCell from "./ImportGridHeaderCell";

interface ImportGridHeaderProps {
    columns: SpreadsheetColumnDefinition[];

    columnChanged: (column: SpreadsheetColumnDefinition, value: string) => void;
}

interface ImportGridHeaderState {}

class ImportGridHeader extends React.Component<
    ImportGridHeaderProps,
    ImportGridHeaderState
> {
    render(): React.ReactNode {
        return (
            <thead className="fixed">
                <tr>
                    {/* Icon column */}
                    <th className="title icon"></th>
                    {/* Hidden column for spacing */}
                    <th
                        className="title"
                        style={{
                            display: "none",
                        }}></th>
                    {/* Column mapping dropdown headers */}
                    {this.props.columns.map((column, index) => (
                        <ImportGridHeaderCell
                            key={index}
                            column={column}
                            columnChanged={this.props.columnChanged}
                        />
                    ))}
                </tr>
            </thead>
        );
    }
}

export default ImportGridHeader;
